import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import Root from "./pages/Root";
import { AppContainer } from "react-hot-loader";
import store from "./store/store";
// Společná inicializace aplikace - polyfill apod.
import "url-search-params-polyfill";
// Import css Bootstrapu
import "font-awesome/css/font-awesome.css";
import "marbes-iconfont/css/mif.less";
import "./app-styles.scss";
import {baseAxios} from "@mc/axios-api";
import {uniStandardErrorInterceptor} from "./utils/uniStandardErrorInterceptor";

baseAxios.interceptors.response.use(undefined, uniStandardErrorInterceptor);

const render = (Component) => {
  const MOUNT_POINT = document.getElementById("root");
  ReactDOM.render(
    <AppContainer>
      <Component store={store} />
    </AppContainer>,
    MOUNT_POINT
  );
};

render(Root);

if (module.hot) {
  module.hot.accept("./pages/Root", () => render(Root));
}
